import React, { Component } from 'react'
import Loader from '../_common/Loader'
import _ from 'lodash'

export class PushStats extends Component {
  constructor (props) {
    super(props)

    this.state = {
      flagFilter: 'all'
    }
  }

  _setFlag = (flagFilter) => {
    this.setState({ flagFilter })
  }

  _getFlagClass = (flag) => {
    console.log('flag: ', flag)
    let isActive
    switch (this.state.flagFilter) {
      case 'all':
        if (flag === 'all') {
          isActive = 'active'
        }
        break
      case 'read':
        if (flag === 'read') {
          isActive = 'active'
        }
        break
      case 'unread':
        if (flag === 'unread') {
          isActive = 'active'
        }
        break
      default:
        break
    }
    return `flag ${isActive}`
  }
  renderResidents = () => {
    const { pushStats } = this.props
    let data
    switch (this.state.flagFilter) {
      case 'all':
        data = this.props.pushStats
        break
      case 'read':
        data = _.filter(pushStats, ['read_status', true])
        break
      case 'unread':
        data = _.filter(pushStats, ['read_status', false])
        break
      default:
        break
    }
    if (pushStats) {
      return data.map(resident => {
        const {
          resident_id,
          resident_name,
          property_name,
          room_number,
          read_status,
          read_date
        } = resident
        return (
          <tr className="resident_card" key={resident_id}>
            <td>{resident_name}</td>
            <td>{property_name}</td>
            <td>{room_number}</td>
            <td>{read_status ? '開封' : '未開封'}</td>
            <td>{read_date || ''}</td>
          </tr>
        )
      })
    }
    return null
  }
  render () {
    if (this.props.loading) return <Loader classname="loader_dot_circle"/>

    return (
      <div className="push_stats">
        <div className="flag_container flex">
          <div className={this._getFlagClass('all')} onClick={ () => { this._setFlag('all') } }>すべて</div>
          <div className={this._getFlagClass('read')} onClick={ () => { this._setFlag('read') } }>開封</div>
          <div className={this._getFlagClass('unread')} onClick={ () => { this._setFlag('unread') } }>未開封</div>
        </div>
        <div className="residents_list">
          <table>
            <thead>
              <tr>
                <th>入居者氏名</th>
                <th>物件名</th>
                <th>部屋番号</th>
                <th>開封状況</th>
                <th>開封日時</th>
              </tr>
            </thead>
            <tbody>
              { this.renderResidents() }
            </tbody>
          </table>
        </div>
      </div>
    )
  }
}

export default PushStats



// WEBPACK FOOTER //
// ./src/components/PushNotifications/PushStats.js